import { setUserActiveGame } from "@/api/user"
import { MIXINS } from "@/utils/mixins"

const state = {
  step: 4,
  transitionStyle: "forward",
  scrollState: -1,
  scrollStateTimeoutFunction: null,
  selectedGame: null,
  username: "",
  selectingPlan: false,
  submittedEstimator: false,
}

const getters = {
  step: state => state.step,
  transitionStyle: state => state.transitionStyle,
  scrollState: state => state.scrollState,
  scrollStateTimeoutFunction: state => state.scrollStateTimeoutFunction,
  selectedGame: state => state.selectedGame,
  username: state => state.username,
  selectingPlan: state => state.selectingPlan,
  submittedEstimator: state => state.submittedEstimator,
}

const mutations = {
  setStep: (state, step) => (state.step = step),
  setTransitionStyle: (state, transitionStyle) =>
    (state.transitionStyle = transitionStyle),
  setScrollState: (state, scrollState) => (state.scrollState = scrollState),
  setScrollStateTimeoutFunction: (state, scrollStateTimeoutFunction) =>
    (state.scrollStateTimeoutFunction = scrollStateTimeoutFunction),
  setSelectedGame: (state, selectedGame) => (state.selectedGame = selectedGame),
  setUsername: (state, username) => (state.username = username),
  setSelectingPlan: (state, selectingPlan) =>
    (state.selectingPlan = selectingPlan),
  setSubmittedEstimator: (state, submittedEstimator) =>
    (state.submittedEstimator = submittedEstimator),
}

const actions = {
  async goForwardToGameSelect ({ commit, dispatch }) {
    await commit("setTransitionStyle", "forward")
    await commit("setStep", 1)
    await dispatch("transitionScrollState", { newState: 1, delay: 1500 })
  },
  async transitionScrollState ({ commit }, { newState, delay }) {
    await commit("setScrollState", -1)
    await commit(
      "setScrollStateTimeoutFunction",
      setTimeout(async () => {
        await commit("setScrollState", newState)
      }, delay)
    )
  },

  async selectGame ({ commit, dispatch }, { game, startPage }) {
    let gameMap = {
      leagueoflegends: "leagueoflegends",
      hearthstone: "hearthstone",
      fortnite: "fortnite",
      csgo: "csgo",
      smash: "super-smash-bros-ultimate",
    }
    MIXINS.methods.trackAnalyticsEvent("Onboarding Select Game", {
      game_name: gameMap[game],
    })
    if (gameMap[game] && game !== "smash") {
      setUserActiveGame(gameMap[game])
        .then(response => {})
        .catch(error => {
          console.log(error)
        })
      await commit("setSelectedGame", game)
      await commit("setTransitionStyle", "forward")
      await commit("setStep", 2)
      setTimeout(() => {
        startPage.scrollTo(0, 0)
      }, 1800)
      dispatch("transitionScrollState", { newState: 2, delay: 3000 })
    } else {
      commit("setStep", 3)
      await commit("setTransitionStyle", "forward")
      setTimeout(() => {
        startPage.scrollTo(0, 0)
      }, 1800)
      dispatch("transitionScrollState", { newState: 3, delay: 1800 })
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/start.js